module.exports = __webpack_public_path__ + "static/img/pc-bg.9f7b462.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc-bg.png
// module id = 5RU8
// module chunks = 1